export default class Header {
  constructor({ text, condition, type = 'h3' }) {
    this.innerText = text
    this.condition = condition
    this.component = type
  }
}
